<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { email, required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import { onMounted, ref } from 'vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import FileUpload from '../../../../components/ui/form/FileUpload.vue'
import TextAreaInput from '../../../../components/ui/form/TextAreaInput.vue'
import RoleListItem from './RoleListItem.vue'
import DateInput from '../../../../components/ui/form/DateInput.vue'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'
import PhoneInput from '../../../../components/ui/form/PhoneInput.vue'
import { Role } from '../../../../types/models'
import IconComponent from '../../../../components/ui/common/IconComponent.vue';

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,
  permissions?: Permission[],
  listCreateName?: string
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
  profile_photo: props.data?.profile_photo || "",
    email: props.data?.email || "",
    mobile_number: props.data?.mobile_number || "",
    mobile_verified_at: props.data?.mobile_verified_at || "",
    user_type: props.data?.user_type || "",
    email_verified_at: props.data?.email_verified_at || "",
    last_logged_in: props.data?.last_logged_in || "",
    cover_photo: props.data?.cover_photo || "",
    signature: props.data?.signature || "",
    profile_text: props.data?.profile_text || "",
    newsletter: props.data?.newsletter || true,
    name: props.data?.name || props.listCreateName || "",
    active: props.data?.active || true,
    uid: props.data?.uid || "",
    roles: props.data?.roles || [],
  });

setFieldRules("name", [required("Name is required")]);
setFieldRules("user_type", [required("User Type is required")]);
setFieldRules("email", [
  required("Email is required"),
  email("Should be a valid email"),
]);
setFieldRules("mobile_number", [required("Mobile No is required")]);


const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const r = roles.value.filter((role) => role.assigned == true)
    console.log(roles.value, r)
    formData.value.roles = roles.value;
    const action = formData.value.uid != '' ? 'update' : 'create'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})


const user_types = [
  { id: "Delivery", name: "Delivery" },
  { id: "Kitchen Staff", name: "Kitchen Staff" },
  { id: "POS User", name: "POS User" },
  { id: "Sales Rep", name: "Sales Rep" },
  { id: "Back Office", name: "Back Office" },
];
const toggleRole = (role: any, value: boolean) => {
  console.log('toggle role', role, 'value', value)
  console.log('isReadOnly', isReadOnly.value)
  if (!isReadOnly.value) {
    const index = roles.value.findIndex(r => r.id === role.id)
    roles.value[index].assigned = value
    //role.assigned = !role.assigned
  }
}

const roles = ref<Role[]>([]);
const permissions = ref<any[]>([]);
const getRoles = async (id: number) => {
  const apiData = {
    id: id,
  };
  const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + 'roles', apiData);
  if (response.success == true) {
    roles.value = response.data;    
    //permissions.value = response.lists.permissions || [];
  }
};

onMounted(() => {
  if (props.data) {
    getRoles(props.data.uid)
  } else {
    getRoles(0)
  }
})


</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit"
    @close="$emit('close')">
    <template #form>
      <div>
        <FileUpload
          accept=".pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.dox,.docx,.html,.xml"
          label="Profile Photo"
          :max-size="5"
          :multiple="false"
          :readonly="isReadOnly"
          :image="true"
          path="users"
          v-model="fields.profile_photo.value"
        />
      </div>
      <div class="grid md:grid-cols-3 gap-6">
        <TextInput
          v-model="fields.name.value"
          label="Name"
          placeholder="Enter Name"
          :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null"
          @blur="fields.name.touched = true"
        />

        <TextInput
          v-model="fields.email.value"
          label="Email"
          :readonly="isReadOnly"
          :error="fields.email.touched ? fields.email.error : null"
          @blur="fields.email.touched = true"
        />

        <PhoneInput
          v-model="fields.mobile_number.value"
          label="Mobile"
          :readonly="isReadOnly"
          :error="
            fields.mobile_number.touched ? fields.mobile_number.error : null
          "
          @blur="fields.mobile_number.touched = true"
        />

        <SearchSelect
          v-model="fields.user_type.value"
          label="User Type"
          :options="user_types"
          :allow-new-record="false"
          :readonly="isReadOnly"
          :error="
            fields.user_type.touched ? fields.user_type.error : null
          "
          @blur="fields.user_type.touched = true"
        />

        <DateInput
          v-model="fields.mobile_verified_at.value"
          label="Mobile Verified at"
          v-if="mode == 'view'"
          :readonly="true"
          type="datetime"
          :error="
            fields.mobile_verified_at.touched
              ? fields.mobile_verified_at.error
              : null
          "
          @blur="fields.mobile_verified_at.touched = true"
        />

        <DateInput
          v-model="fields.email_verified_at.value"
          label="Email Verified at"
          v-if="mode == 'view'"
          :readonly="true"
          type="datetime"
          :error="
            fields.email_verified_at.touched
              ? fields.email_verified_at.error
              : null
          "
          @blur="fields.email_verified_at.touched = true"
        />

        <DateInput
          v-model="fields.last_logged_in.value"
          label="Last Logged In"
          v-if="mode == 'view'"
          :readonly="true"
          type="datetime"
          :error="
            fields.last_logged_in.touched ? fields.last_logged_in.error : null
          "
          @blur="fields.last_logged_in.touched = true"
        />

        <CheckInput
          v-model="fields.newsletter.value"
          :readonly="isReadOnly"
          label="Subscribed to Newsletter"
          :error="fields.newsletter.touched ? fields.newsletter.error : null"
          @blur="fields.newsletter.touched = true"
        />

        <CheckInput
          v-model="fields.active.value"
          :readonly="isReadOnly"
          label="Active"
          :error="fields.active.touched ? fields.active.error : null"
          @blur="fields.active.touched = true"
        />
      </div>
      <div class="p-4 bg-gray-50 dark:bg-gray-900 rounded-lg" v-if="mode != 'create'" id="roles" >
        <div class="">
          <span class="text-2xl font-medium text-gray-900 dark:text-white">User Roles</span>
          <div>
            <RoleListItem
              v-for="role in roles"
              class="mt-2"
              :key="role.id"
              :readonly="isReadOnly"
              :role="role"
              :model-value="role.assigned"
              @changed="toggleRole"
            />
          </div>
        </div>
      </div>
      <div class="p-4 bg-gray-50 dark:bg-gray-900 rounded-lg" id="permissions" v-if="mode != 'create'" >
        <div class="">
          <span class="text-2xl font-medium text-gray-900 dark:text-white">Allowed Permissions</span>
          <div>
            <div
              v-for="p in permissions"
              :key="p.id"
            >
                <div class="flex items-center gap-2 py-1">
                <IconComponent :name="p.icon_css" />
                <h1 class="text-base font-medium text-gray-900 dark:text-white truncate">{{p.name}}</h1>
                </div>
              <div v-for="j in p.modules" :key="j.id" class="ml-4">
                <div class="flex items-center gap-2 py-1"><IconComponent :name="j.icon_css" /><h2 class="text-base font-medium text-gray-900 dark:text-white truncate">{{j.name}}</h2></div>
                  <div v-for="m in j.modules" :key="m.id" class="ml-8">
                  <div class="flex items-center gap-2 py-1"><IconComponent :name="m.icon_css" /><h2 class="text-base font-medium text-gray-900 dark:text-white truncate">{{m.name}}</h2></div>
                    <div class="ml-8 flex items-center gap-4 py-1 overflow-x-auto">
                    <div
                      class="text-sm text-gray-600 dark:text-gray-400 whitespace-pre-line break-words"
                      v-for="perm in m.permissions"
                      :key="perm.id"
                      style="white-space: pre-line; word-break: break-word;"
                    >
                      {{ perm.name }}
                    </div>
                    </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <TextAreaInput
          v-model="fields.profile_text.value"
          label="Profile Text"
          :rows="5"
          :readonly="isReadOnly"
          :error="
            fields.profile_text.touched ? fields.profile_text.error : null
          "
          @blur="fields.profile_text.touched = true"
        />
      </div>
      <div>
        <FileUpload
          accept=".pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.dox,.docx,.html,.xml"
          :max-size="5"
          label="Cover Photo"
          :multiple="false"
          :readonly="isReadOnly"
          :image="true"
          path="users"
          v-model="fields.cover_photo.value"
        />
      </div>
      <div>
        <FileUpload
          accept=".pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.dox,.docx,.html,.xml"
          :max-size="5"
          label="Signature"
          :multiple="false"
          :readonly="isReadOnly"
          :image="true"
          path="users"
          v-model="fields.signature.value"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>